angular.module('callX').service('DateService', ['UserService', '$rootScope',
  function (UserService, $rootScope){

    var timezone;
    var DateObj = {};
    DateObj.activeDate = "today";
    var currentDateInTimeZone;
    DateObj.timezone = timezone;
    DateObj.dateRangeValue = [currentDateInTimeZone, currentDateInTimeZone];

    var createUpdatedDateObj = function(){
      currentDateInTimeZone = moment().tz(timezone).format("MMM D, YYYY");
      DateObj.timezone = timezone;
      DateObj.dateRangeValue = [currentDateInTimeZone, currentDateInTimeZone];
      $rootScope.$broadcast('dateObjUpdate', DateObj);
    };

    $rootScope.$on('currentUserUpdate', function(event, currentUserData) {
//      console.log("userUpdate at Dates Service");
      timezone = currentUserData.time_zone;
      createUpdatedDateObj();
    });

    return{
      setDateObj: function(activeDate, dateRangeValue) {
        DateObj.activeDate = activeDate;
        DateObj.dateRangeValue = dateRangeValue;
      },
      getDateObj: function() {
        return DateObj;
      }
    }
  }]);